import { useFilterSpices } from "@/hooks/useFilter";
import { EmptySpicesState } from "./EmptySpicesState";
import { Ingredients } from "./Ingredients";
import { Nutrition } from "./Nutrition";
import { ReactNode } from "react";

interface NutritionFactsProps {
  children?: ReactNode;
  showEmptyState?: boolean;
  className?: string;
  gapClass?: string;
}

export default function NutritionFacts({
  children,
  className = "",
  gapClass = "gap-8",
}: NutritionFactsProps) {
  const [spices] = useFilterSpices();
  const isEmpty = !spices || spices.size === 0;

  if (isEmpty) return <EmptySpicesState />;

  return (
    <div className={`flex flex-col ${gapClass} ${className} p-4 overflow-y-auto min-h-0`}>
      {children && <section>{children}</section>}
        <>
          <section>
            <Ingredients spices={spices} />
          </section>

          <hr></hr>
          <section>
            <Nutrition spices={spices} />
          </section>
        </>
    </div>
  );
}
